
import { useState, useEffect } from "react";
import { Container, Row, Col, Form, InputGroup, Spinner, Alert } from "react-bootstrap";
// New package button
import { Button } from '@veeyaainnovatives/button';
import Faqsection from "../components/sections/faq-section";
import { Banner } from '@veeyaainnovatives/banner';
import Bannerimg from '../assets/images/gallery/gallery-3.jpg';
import axios from 'axios';
import { getApiUrl } from '../config/api';

const Faq = () => {
    const [faqs, setFaqs] = useState([]);
    const [filteredFaqs, setFilteredFaqs] = useState([]);
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedService, setSelectedService] = useState('');

     const pageDetails = {
    title: "Frequently Asked **Questions** ?",
        description: "Find answers to common questions about our services, processes, and more.",
    breadcrumb: [
      { name: "Home", link: "/" },
      { name: "FAQ'S", link: "/faq" } 
    ],
    };

    // Scroll to top on mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Fetch FAQs from API
    useEffect(() => {
        const fetchFaqs = async () => {
            try {
                setLoading(true);
                setError('');
                
                const response = await axios.get(getApiUrl('api/public/faqs'));
                
                if (response.data.success && response.data.data) {
                    // Filter only active FAQs and sort by order
                    const activeFaqs = response.data.data
                        .filter(faq => faq.is_active === true)
                        .sort((a, b) => (a.order || 0) - (b.order || 0));
                    
                    setFaqs(activeFaqs);
                    setFilteredFaqs(activeFaqs);
                } else {
                    setFaqs([]);
                    setFilteredFaqs([]);
                }
            } catch (error) {
                console.error('Error fetching FAQs:', error);
                setError('Failed to load FAQs. Please try again later.');
                setFaqs([]);
                setFilteredFaqs([]);
            } finally {
                setLoading(false);
            }
        };

        fetchFaqs();
    }, []);

    // Fetch all services (including child services) for filter dropdown
    useEffect(() => {
        const fetchServices = async () => {
            try {
                const response = await axios.get(getApiUrl('api/public/services/all-with-children'));
                
                if (response.data.success && response.data.data) {
                    const allServicesList = [];
                    
                    // Loop through all services and flatten parent + child services
                    response.data.data.forEach(service => {
                        // Add parent service if published
                        if (service.is_published === 1) {
                            allServicesList.push({
                                id: service.id,
                                title: service.title || service.name,
                                name: service.name || service.title,
                                is_parent: true
                            });
                        }
                        
                        // Add child services (sub_services) if they exist
                        if (service.sub_services && Array.isArray(service.sub_services)) {
                            service.sub_services.forEach(childService => {
                                if (childService.is_published === 1) {
                                    allServicesList.push({
                                        id: childService.id,
                                        title: childService.title || childService.name,
                                        name: childService.name || childService.title,
                                        is_parent: false,
                                        parent_id: service.id,
                                        parent_title: service.title || service.name
                                    });
                                }
                            });
                        }
                    });
                    
                    // Sort by title/name
                    allServicesList.sort((a, b) => {
                        const nameA = (a.title || a.name || '').toLowerCase();
                        const nameB = (b.title || b.name || '').toLowerCase();
                        return nameA.localeCompare(nameB);
                    });
                    
                    setServices(allServicesList);
                }
            } catch (error) {
                console.error('Error fetching services:', error);
            }
        };

        fetchServices();
    }, []);

    // Filter FAQs based on search query and selected service (Client-side filtering)
    useEffect(() => {
        let filtered = [...faqs];

        // Filter by service (using service_id from API response)
        if (selectedService) {
            filtered = filtered.filter(faq => {
                const serviceId = faq.service_id;
                return serviceId === parseInt(selectedService) || 
                       String(serviceId) === String(selectedService);
            });
        }

        // Filter by search query (search in question and answer)
        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase();
            filtered = filtered.filter(faq => {
                const question = faq.question || '';
                const answer = faq.answer || '';
                return question.toLowerCase().includes(query) ||
                       answer.toLowerCase().includes(query);
            });
        }

        setFilteredFaqs(filtered);
    }, [searchQuery, selectedService, faqs]);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const handleServiceChange = (e) => {
        setSelectedService(e.target.value);
    };

    const clearFilters = () => {
        setSearchQuery('');
        setSelectedService('');
    };

    return (
        <>
            <Banner img={Bannerimg} pageDetails={pageDetails} highlightClassName="theme-color-green" />
         <div className="body-wrap overflow-hidden mt-5">
            <section className='py-4'>
                <div className="position-relative">
                    <div className="design-circle-our-worksection position-absolute"></div>
                        <Container className="mb-5">
                            {/* Search and Filter Section */}
                            <Row className="mb-5">
                                <Col lg={12}>
                                    <Row className="g-3">
                                        {/* Search Input - Same style as Blogs */}
                                        <Col md={6}>
                                            <Form
                                                onSubmit={(e) => {
                                                    e.preventDefault();
                                                }}
                                            >
                                                <InputGroup className="position-relative">
                                                    <Form.Control
                                                        placeholder="Search for FAQs..."
                                                        value={searchQuery}
                                                        onChange={handleSearchChange}
                                                    />
                                                    
                                                    {/* Clear Icon */}
                                                    {searchQuery.length > 0 && (
                                                        <span
                                                            className="clear-btn"
                                                            onClick={() => setSearchQuery("")}
                                                        >
                                                            &times;
                                                        </span>
                                                    )}

                                                    <Button 
                                                      type="button"
                                                      className="btn-search"
                                                      backgroundColor="#677a58"
                                                      color="#ffffff"
                                                      hoverBackgroundColor="#5a6a4a"
                                                      width="75px"
                                                      height="57px"
                                                      borderRadius="0px 100px 100px 0px"
                                                      padding="0"
                                                      icon="fa-solid fa-magnifying-glass"
                                                    />
                                                </InputGroup>
                                            </Form>
                                        </Col>

                                        {/* Service Filter Dropdown - Same style as Search */}
                                        <Col md={6}>
                                            <Form
                                                onSubmit={(e) => {
                                                    e.preventDefault();
                                                }}
                                            >
                                                <InputGroup className="position-relative">
                                                    <Form.Select
                                                        value={selectedService}
                                                        onChange={handleServiceChange}
                                                        className="form-control"
                                                        style={{
                                                            border: 'none',
                                                            padding: '12px 40px 12px 16px',
                                                            fontSize: '15px',
                                                            minHeight: '56px',
                                                            appearance: 'none',
                                                            backgroundImage: 'none',
                                                            borderRadius: '100px',
                                                            borderTopRightRadius: '0',
                                                            borderBottomRightRadius: '0'
                                                        }}
                                                    >
                                                        <option value="">All Services</option>
                                                        {services.map((service) => (
                                                            <option key={service.id} value={service.id}>
                                                                {service.title || service.name}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                    
                                                    {/* Clear Icon for Dropdown */}
                                                    {selectedService && (
                                                        <span
                                                            className="clear-btn"
                                                            onClick={() => setSelectedService("")}
                                                        >
                                                            &times;
                                                        </span>
                                                    )}

                                                    <Button 
                                                      type="button"
                                                      className="btn-search"
                                                      backgroundColor="#677a58"
                                                      color="#ffffff"
                                                      hoverBackgroundColor="#5a6a4a"
                                                      width="75px"
                                                      height="57px"
                                                      borderRadius="0px 100px 100px 0px"
                                                      padding="0"
                                                      icon="fa-solid fa-filter"
                                                    />
                                                </InputGroup>
                                            </Form>
                                        </Col>
                                    </Row>

                                    {/* Results Count */}
                                    {(searchQuery || selectedService) && (
                                        <div className="mt-3">
                                            <span style={{
                                                color: '#6c757d',
                                                fontSize: '14px',
                                                fontWeight: '500'
                                            }}>
                                                <i className="fa fa-info-circle me-2" style={{ color: '#677a58' }}></i>
                                                Showing <strong style={{ color: '#677a58' }}>{filteredFaqs.length}</strong> of <strong>{faqs.length}</strong> FAQs
                                            </span>
                                        </div>
                                    )}
                                </Col>
                            </Row>

                            {/* Loading State */}
                            {loading && (
                                <div className="text-center py-5">
                                    <Spinner animation="border" style={{ color: '#677a58' }} />
                                    <p className="mt-3 text-muted">Loading FAQs...</p>
                                </div>
                            )}

                            {/* Error State */}
                            {error && !loading && (
                                <Alert variant="danger" className="mb-4">
                                    {error}
                                </Alert>
                            )}

                            {/* FAQs Section */}
                            {!loading && !error && (
                                <>
                                    {filteredFaqs.length > 0 ? (
                                        <Faqsection 
                                            show={true} 
                                            faqs={filteredFaqs}
                                        />
                                    ) : (
                                        <div className="text-center py-5">
                                            <p className="text-muted">
                                                {searchQuery || selectedService 
                                                    ? 'No FAQs found matching your search criteria.' 
                                                    : 'No FAQs available at the moment.'}
                                            </p>
                                        </div>
                                    )}
                                </>
                            )}
                        </Container>
                </div>
            </section>
        </div>
        </>
    );
};

export default Faq;